import * as React from 'react';
import { trackJKListPromoIconClick, trackJKListPromoIconHover } from '../../actions/analytics';
import { PromoBlock } from '../../components/PromoBlock';
import { INewbuildingPromo } from '../../types/newbuilding';

interface IPromoBlockContainerProps {
  promos: INewbuildingPromo[];
  newbuildingUrl: string;
}

export const PromoBlockContainer = ({ promos, newbuildingUrl }: IPromoBlockContainerProps) => {
  const handlePromoClick = React.useCallback((promo: INewbuildingPromo) => {
    trackJKListPromoIconClick(promo.promoType);
  }, []);

  const handlePromoHover = React.useCallback((promo: INewbuildingPromo) => {
    trackJKListPromoIconHover(promo.promoType);
  }, []);

  return (
    <PromoBlock
      promos={promos}
      url={newbuildingUrl + '#promoList'}
      onPromoClick={handlePromoClick}
      onPromoHover={handlePromoHover}
    />
  );
};
